// @flow

import React from 'react';
import { splitLong } from 'services/format/splitDate';
import './DateCard.scss';

type Props = {
  date: string,
  timeZone: string,
  locale: string
}
const DateCard = ({ date, timeZone, locale }: Props) => {
  const dateSliced = splitLong(date, timeZone, locale);
  return (
    <div className="date-card">
      <div>{dateSliced.month}</div>
      <div>{dateSliced.day}</div>
      <div>{dateSliced.year}</div>
    </div>
  );
};

export default DateCard;
